import { useRef, useEffect } from 'react';
import { Bold, Italic, Underline, List, ListOrdered, Link, Heading2, Heading3, Quote } from 'lucide-react';

const ToolbarBtn = ({ onClick, title, children, active }) => (
  <button type="button" onMouseDown={(e) => { e.preventDefault(); onClick(); }} title={title}
    className={`px-2 py-1 rounded text-sm font-medium transition-colors ${active ? 'bg-red-100 text-red-700' : 'hover:bg-gray-100 text-gray-700'}`}>
    {children}
  </button>
);

export default function SimpleRichEditor({ value, onChange, placeholder = 'Escreva o conteúdo aqui...' }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== value) {
      ref.current.innerHTML = value || '';
    }
  }, []);

  const exec = (cmd, arg = null) => {
    ref.current.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };

  const insertLink = () => {
    const url = prompt('URL do link:');
    if (url) exec('createLink', url);
  };

  return (
    <div className="border border-gray-300 rounded-lg overflow-hidden focus-within:ring-2 focus-within:ring-red-500 focus-within:border-red-500">
      <div className="flex flex-wrap gap-1 p-2 bg-gray-50 border-b border-gray-200">
        <ToolbarBtn onClick={() => exec('bold')} title="Negrito (Ctrl+B)"><Bold size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('italic')} title="Itálico (Ctrl+I)"><Italic size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('underline')} title="Sublinhado (Ctrl+U)"><Underline size={14} /></ToolbarBtn>
        <div className="w-px bg-gray-300 mx-1" />
        <ToolbarBtn onClick={() => exec('formatBlock', 'h2')} title="Título H2"><Heading2 size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('formatBlock', 'h3')} title="Título H3"><Heading3 size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('formatBlock', 'blockquote')} title="Citação"><Quote size={14} /></ToolbarBtn>
        <div className="w-px bg-gray-300 mx-1" />
        <ToolbarBtn onClick={() => exec('insertUnorderedList')} title="Lista não ordenada"><List size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('insertOrderedList')} title="Lista numerada"><ListOrdered size={14} /></ToolbarBtn>
        <div className="w-px bg-gray-300 mx-1" />
        <ToolbarBtn onClick={insertLink} title="Inserir link"><Link size={14} /></ToolbarBtn>
        <ToolbarBtn onClick={() => exec('removeFormat')} title="Remover formatação">
          <span className="text-xs">T</span>
        </ToolbarBtn>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={() => onChange(ref.current.innerHTML)}
        className="min-h-[300px] p-4 focus:outline-none prose prose-sm max-w-none text-gray-800"
        style={{ lineHeight: '1.7', fontFamily: 'Manrope, sans-serif' }}
        data-testid="rich-editor-content"
      />
      {!value && (
        <style>{`[data-testid="rich-editor-content"]:empty:before { content: attr(data-placeholder); color: #9ca3af; } `}</style>
      )}
    </div>
  );
}
